export enum ReportPageAction {
  EditReport,
  EditUpdatedReport,
  DraftReportWarning,

  SetPreviewImage,
  CloneDraft,
  DownloadPDF,
  ToggleNotifications,
  ViewStars,

  MoveReport,
  DeleteDraft,
}
